import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

const StockInPage = () => {
  const [stockIns, setStockIns] = useState([]);
  const [items, setItems] = useState([]);
  const [branches] = useState(["Lehulu", "Kalkidan", "Store"]);
  const [categories, setCategories] = useState([]);
  const [filters, setFilters] = useState({
    branch: "",
    category: "",
    search: "",
    specificDate: "",
    startDate: "",
    endDate: "",
    monthYear: "",
    reserve_for_branch: "",
  });
  const [formData, setFormData] = useState({
    item: null,
    quantity: "",
    unitprice: "",
    saleprice: "",
    note: "",
  });
  const [editingId, setEditingId] = useState(null);
  const [isItemModalOpen, setIsItemModalOpen] = useState(false);
  const [itemFilters, setItemFilters] = useState({
    branch: "",
    category: "",
    search: "",
    reserve_for_branch: "",
  });
  const [isLoading, setIsLoading] = useState({
    submit: false,
    cancel: false,
    selectItem: false,
    closeModal: false,
    edit: false,
    delete: false,
    openModal: false,
  });
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [viewingItem, setViewingItem] = useState(null);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editFormData, setEditFormData] = useState({
    item: null,
    quantity: "",
    unitprice: "",
    saleprice: "",
    note: "",
  });

  useEffect(() => {
    fetchStockIns();
    fetchItems();
    fetchCategories();
  }, [
    filters.branch,
    filters.category,
    filters.search,
    filters.specificDate,
    filters.startDate,
    filters.endDate,
    filters.monthYear,
    filters.reserve_for_branch,
    itemFilters.branch,
    itemFilters.category,
    itemFilters.search,
    itemFilters.reserve_for_branch,
  ]);

  const fetchStockIns = async () => {
    try {
      let url = filters.branch
        ? `https://backend.lehuluet.com/api/stockins/stockins/by-branch/${filters.branch}`
        : "https://backend.lehuluet.com/api/stockins/stockins";

      const queryParams = [];

      if (filters.specificDate) {
        queryParams.push(`specificDate=${filters.specificDate}`);
      } else if (filters.startDate && filters.endDate) {
        queryParams.push(`startDate=${filters.startDate}`);
        queryParams.push(`endDate=${filters.endDate}`);
      } else if (filters.monthYear) {
        queryParams.push(`monthYear=${filters.monthYear}`);
      }

      if (queryParams.length > 0) {
        url += `?${queryParams.join("&")}`;
      }

      const response = await axios.get(url);
      setStockIns(response.data.data);
    } catch (error) {
      toast.error("Error fetching stock-ins");
    }
  };

  const fetchItems = async () => {
    try {
      const url = itemFilters.branch
        ? `https://backend.lehuluet.com/api/items/items/branch/${itemFilters.branch}`
        : "https://backend.lehuluet.com/api/items/items";
      const response = await axios.get(url);
      let filteredData = response.data.data;

      if (itemFilters.category) {
        filteredData = filteredData.filter((item) => {
          const categoryId = item.category?._id
            ? item.category._id
            : item.category;
          return categoryId === itemFilters.category;
        });
      }
      if (itemFilters.search) {
        const searchLower = itemFilters.search.toLowerCase();
        filteredData = filteredData.filter((item) => {
          return (
            item.size?.toLowerCase().includes(searchLower) ||
            item.brand?.toLowerCase().includes(searchLower) ||
            item.ampere?.toLowerCase().includes(searchLower) ||
            item.uniquesize?.toLowerCase().includes(searchLower) ||
            item.position?.toLowerCase().includes(searchLower)
          );
        });
      }

      if (itemFilters.reserve_for_branch) {
        filteredData = filteredData.filter(
          (item) => item.reserve_for_branch === itemFilters.reserve_for_branch
        );
      }

      setItems(filteredData);
    } catch (error) {
      toast.error("Error fetching items");
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await axios.get(
        "https://backend.lehuluet.com/api/categories/categories"
      );
      setCategories(response.data.data);
    } catch (error) {
      toast.error("Error fetching categories");
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;

    if (name === "specificDate" || name === "monthYear") {
      setFilters({
        ...filters,
        [name]: value,
        startDate: "",
        endDate: "",
        ...(name === "specificDate" && { monthYear: "" }),
        ...(name === "monthYear" && { specificDate: "" }),
      });
    } else {
      setFilters({ ...filters, [name]: value });
    }
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleEditInputChange = (e) => {
    setEditFormData({ ...editFormData, [e.target.name]: e.target.value });
  };

  const handleItemFilterChange = (e) => {
    setItemFilters({ ...itemFilters, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.item) {
      toast.error("Please select an item");
      return;
    }
    setIsLoading((prev) => ({ ...prev, submit: true }));
    try {
      const submitData = {
        item: formData.item._id,
        quantity: formData.quantity,
        unitprice: formData.unitprice,
        saleprice: formData.saleprice,
        note: formData.note,
      };
      const token = localStorage.getItem("token");
      await axios.post(
        "https://backend.lehuluet.com/api/stockins/stockins",
        submitData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      toast.success("Stock-in created successfully");
      fetchStockIns();
      resetForm();
    } catch (error) {
      toast.error(error.response?.data?.message || "Error saving stock-in");
    } finally {
      setIsLoading((prev) => ({ ...prev, submit: false }));
    }
  };

  const handleEdit = (stockIn) => {
    setIsLoading((prev) => ({ ...prev, edit: true }));
    setEditingId(stockIn._id);
    setEditFormData({
      item: stockIn.item,
      quantity: stockIn.quantity || "",
      unitprice: stockIn.unitprice || "",
      saleprice: stockIn.item.saleprice || "",
      note: stockIn.note || "",
    });
    setIsEditModalOpen(true);
    setIsLoading((prev) => ({ ...prev, edit: false }));
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    if (!editFormData.item) {
      toast.error("Please select an item");
      return;
    }
    setIsLoading((prev) => ({ ...prev, submit: true }));
    try {
      const submitData = {
        item: editFormData.item._id,
        quantity: editFormData.quantity,
        unitprice: editFormData.unitprice,
        saleprice: editFormData.saleprice,
        note: editFormData.note,
      };
      const token = localStorage.getItem("token");
      await axios.put(
        `https://backend.lehuluet.com/api/stockins/stockins/${editingId}`,
        submitData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      toast.success("Stock-in updated successfully");
      fetchStockIns();
      setIsEditModalOpen(false);
      setEditingId(null);
      setEditFormData({
        item: null,
        quantity: "",
        unitprice: "",
        saleprice: "",
        note: "",
      });
    } catch (error) {
      toast.error(error.response?.data?.message || "Error updating stock-in");
    } finally {
      setIsLoading((prev) => ({ ...prev, submit: false }));
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this stock-in?")) {
      setIsLoading((prev) => ({ ...prev, delete: true }));
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          throw new Error(
            "No authentication token found. Please log in again."
          );
        }
        await axios.delete(
          `https://backend.lehuluet.com/api/stockins/stockins/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        toast.success("Stock-in deleted successfully");
        fetchStockIns();
      } catch (error) {
        toast.error(
          error.response?.data?.error ||
            error.message ||
            "Error deleting stock-in"
        );
      } finally {
        setIsLoading((prev) => ({ ...prev, delete: false }));
      }
    }
  };

  const resetForm = () => {
    setIsLoading((prev) => ({ ...prev, cancel: true }));
    setFormData({
      item: null,
      quantity: "",
      unitprice: "",
      saleprice: "",
      note: "",
    });
    setEditingId(null);
    setIsLoading((prev) => ({ ...prev, cancel: false }));
  };

  const filteredStockIns = stockIns.filter((stockIn) => {
    const stockInDate = new Date(stockIn.created_at);
    const matchesBranch = filters.branch
      ? stockIn.item?.branch === filters.branch
      : true;
    const matchesCategory = filters.category
      ? (stockIn.item?.category?._id || stockIn.item?.category) ===
        filters.category
      : true;
    const matchesSearch = filters.search
      ? (stockIn.item?.name || "")
          .toLowerCase()
          .includes(filters.search.toLowerCase()) ||
        (stockIn.item?.brand || "")
          .toLowerCase()
          .includes(filters.search.toLowerCase())
      : true;
    const matchesReserveForBranch = filters.reserve_for_branch
      ? stockIn.item?.reserve_for_branch === filters.reserve_for_branch
      : true;

    let matchesDate = true;

    if (filters.specificDate) {
      const specificDate = new Date(filters.specificDate);
      matchesDate = stockInDate.toDateString() === specificDate.toDateString();
    } else if (filters.startDate && filters.endDate) {
      const start = new Date(filters.startDate);
      const end = new Date(filters.endDate);
      end.setHours(23, 59, 59, 999);
      matchesDate = stockInDate >= start && stockInDate <= end;
    } else if (filters.monthYear) {
      const [year, month] = filters.monthYear.split("-");
      matchesDate =
        stockInDate.getFullYear() === parseInt(year) &&
        stockInDate.getMonth() === parseInt(month) - 1;
    }

    return (
      matchesBranch &&
      matchesCategory &&
      matchesSearch &&
      matchesDate &&
      matchesReserveForBranch
    );
  });

  const selectItem = (item) => {
    setIsLoading((prev) => ({ ...prev, selectItem: true }));
    setFormData({ ...formData, item });
    setIsItemModalOpen(false);
    setItemFilters({
      branch: "",
      category: "",
      search: "",
      reserve_for_branch: "",
    });
    setIsLoading((prev) => ({ ...prev, selectItem: false }));
  };

  const openModal = () => {
    setIsLoading((prev) => ({ ...prev, openModal: true }));
    setIsItemModalOpen(true);
    fetchItems();
    setIsLoading((prev) => ({ ...prev, openModal: false }));
  };

  const closeModal = () => {
    setIsLoading((prev) => ({ ...prev, closeModal: true }));
    setIsItemModalOpen(false);
    setIsLoading((prev) => ({ ...prev, closeModal: false }));
  };

  const openViewModal = (itemOrStockIn) => {
    setViewingItem(itemOrStockIn);
    setIsViewModalOpen(true);
  };

  const closeViewModal = () => {
    setIsViewModalOpen(false);
    setViewingItem(null);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setEditingId(null);
    setEditFormData({
      item: null,
      quantity: "",
      unitprice: "",
      saleprice: "",
      note: "",
    });
  };

  const exportToCSV = () => {
    if (!filteredStockIns.length) return;

    const headers = [
      "Date",
      "Brand",
      "Branch",
      "Category",
      "Size",
      "UniqueSize / AMP",
      "Position / Origin",
      "Quantity",
      "Unit Price",
      "Total",
      "Note",
    ];
    const rows = filteredStockIns.map((stockIn) => [
      new Date(stockIn.created_at).toLocaleDateString() || "N/A",
      stockIn.item?.brand || "N/A",
      stockIn.item?.branch || "N/A",
      stockIn.item?.category?.name || "N/A",
      stockIn.item?.size || "N/A",
      stockIn.item?.uniquesize || stockIn.item?.ampere || "N/A",
      stockIn.item?.position || stockIn.item?.origin || "N/A",
      stockIn.quantity || 0,
      stockIn.unitprice || 0,
      (stockIn.quantity * stockIn.unitprice || 0).toFixed(2),
      stockIn.note || "-----",
    ]);

    const csvContent = [
      headers.join(","),
      ...rows.map((row) => row.map((cell) => `"${cell}"`).join(",")),
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "stock_ins.csv";
    link.click();
    URL.revokeObjectURL(link.href);
  };

  return (
    <div className="container mx-auto p-4">
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-4 gap-4">
        <h1 className="text-2xl text-teal-700 font-bold">Stock In</h1>
        <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
          <button
            onClick={() => setIsFilterVisible(!isFilterVisible)}
            className="w-full sm:w-auto px-3 py-1 bg-teal-500 text-white rounded-md text-sm hover:bg-teal-600 transition-colors"
          >
            {isFilterVisible ? "Hide Filters" : "Show Filters"}
          </button>
          <button
            onClick={exportToCSV}
            className="w-full sm:w-auto px-3 py-1 bg-green-500 text-white rounded-md text-sm hover:bg-green-600 transition-colors"
          >
            Export to CSV
          </button>
        </div>
      </div>

      {isFilterVisible && (
        <div className="bg-gray-100 p-4 rounded-lg shadow-sm mb-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
            <div>
              <label className="block text-gray-700 mb-1">Branch</label>
              <select
                name="branch"
                value={filters.branch}
                onChange={handleFilterChange}
                className="w-full p-2 border rounded-md text-sm focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
              >
                <option value="">All Branches</option>
                {branches.map((branch) => (
                  <option key={branch} value={branch}>
                    {branch}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-gray-700 mb-1">
                Reserve for Branch
              </label>
              <select
                name="reserve_for_branch"
                value={filters.reserve_for_branch}
                onChange={handleFilterChange}
                className="w-full p-2 border rounded-md text-sm focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
              >
                <option value="">All Branches</option>
                {branches.map((branch) => (
                  <option key={branch} value={branch}>
                    {branch}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-gray-700 mb-1">Category</label>
              <select
                name="category"
                value={filters.category}
                onChange={handleFilterChange}
                className="w-full p-2 border rounded-md text-sm focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
              >
                <option value="">All Categories</option>
                {categories.map((category) => (
                  <option key={category._id} value={category._id}>
                    {category.name}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-gray-700 mb-1">Search</label>
              <input
                type="text"
                name="search"
                value={filters.search}
                onChange={handleFilterChange}
                placeholder="Search by name or brand..."
                className="w-full p-2 border rounded-md text-sm focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <label className="block text-gray-700 mb-1">Specific Date</label>
              <input
                type="date"
                name="specificDate"
                value={filters.specificDate}
                onChange={handleFilterChange}
                className="w-full p-2 border rounded-md text-sm focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
              />
            </div>

            <div>
              <label className="block text-gray-700 mb-1">Start Date</label>
              <input
                type="date"
                name="startDate"
                value={filters.startDate}
                onChange={handleFilterChange}
                className="w-full p-2 border rounded-md text-sm focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
              />
            </div>

            <div>
              <label className="block text-gray-700 mb-1">End Date</label>
              <input
                type="date"
                name="endDate"
                value={filters.endDate}
                onChange={handleFilterChange}
                className="w-full p-2 border rounded-md text-sm focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
              />
            </div>

            <div>
              <label className="block text-gray-700 mb-1">Month/Year</label>
              <input
                type="month"
                name="monthYear"
                value={filters.monthYear}
                onChange={handleFilterChange}
                className="w-full p-2 border rounded-md text-sm focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
              />
            </div>
          </div>
        </div>
      )}

      <form onSubmit={handleSubmit} className="bg-gray-100 p-4 rounded mb-6">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
          <div className="w-full">
            <label className="block text-gray-700 mb-1">Select Item</label>
            <button
              type="button"
              onClick={openModal}
              disabled={isLoading.openModal}
              className="w-full px-4 py-3 rounded-xl border border-gray-300 bg-white text-gray-600 flex items-center justify-center gap-2 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-300 shadow-sm hover:shadow-md"
            >
              {isLoading.openModal ? (
                <span className="animate-pulse">Loading...</span>
              ) : formData.item ? (
                <span className="truncate font-medium text-gray-700">
                  {formData.item.name} - {formData.item.brand}
                </span>
              ) : (
                <>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    className="w-5 h-5 text-gray-400"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                  <span className="text-gray-500 font-medium">Select Item</span>
                </>
              )}
            </button>
          </div>

          <div>
            <label className="block text-gray-700 mb-1">Quantity</label>
            <input
              type="number"
              name="quantity"
              value={formData.quantity}
              onChange={handleInputChange}
              placeholder="Quantity"
              className="w-full p-2 border rounded"
              required
            />
          </div>

          <div>
            <label className="block text-gray-700 mb-1">Unit Price</label>
            <input
              type="number"
              name="unitprice"
              value={formData.unitprice}
              onChange={handleInputChange}
              placeholder="Unit Price"
              className="w-full p-2 border rounded"
              required
            />
          </div>

          <div>
            <label className="block text-gray-700 mb-1">Sale Price</label>
            <input
              type="number"
              name="saleprice"
              value={formData.saleprice}
              onChange={handleInputChange}
              placeholder="Sale Price"
              className="w-full p-2 border rounded"
              required
              step="0.01"
            />
          </div>

          <div>
            <label className="block text-gray-700 mb-1">Note</label>
            <input
              type="text"
              name="note"
              value={formData.note}
              onChange={handleInputChange}
              placeholder="Note (optional)"
              className="w-full p-2 border rounded"
            />
          </div>
        </div>
        <div className="mt-4 flex gap-2">
          <button
            type="submit"
            disabled={isLoading.submit}
            className="bg-teal-500 text-white px-4 py-2 rounded hover:bg-teal-600 disabled:opacity-50"
          >
            {isLoading.submit ? "Loading..." : "Create"} Stock-In
          </button>
          {editingId && (
            <button
              type="button"
              onClick={resetForm}
              disabled={isLoading.cancel}
              className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 disabled:opacity-50"
            >
              {isLoading.cancel ? "Loading..." : "Cancel"}
            </button>
          )}
        </div>
      </form>

      {isItemModalOpen && (
        <div className="fixed inset-0 bg-gray-400 bg-opacity-50 flex items-center justify-center">
          <div className="bg-white p-6 rounded-lg w-full max-w-3xl">
            <h2 className="text-xl font-bold mb-4">Select Item</h2>

            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
              <div>
                <label className="block text-gray-700 mb-1">Branch</label>
                <select
                  name="branch"
                  value={itemFilters.branch}
                  onChange={handleItemFilterChange}
                  className="w-full p-2 border rounded"
                >
                  <option value="">All Branches</option>
                  {branches.map((branch) => (
                    <option key={branch} value={branch}>
                      {branch}
                    </option>
                  ))}
                </select>
              </div>

              {itemFilters.branch === "Store" && (
                <div>
                  <label className="block text-gray-700 mb-1">
                    Reserve for Branch
                  </label>
                  <select
                    name="reserve_for_branch"
                    value={itemFilters.reserve_for_branch}
                    onChange={handleItemFilterChange}
                    className="w-full p-2 border rounded"
                  >
                    <option value="">All Branches</option>
                    {branches.map((branch) => (
                      <option key={branch} value={branch}>
                        {branch}
                      </option>
                    ))}
                  </select>
                </div>
              )}

              <div>
                <label className="block text-gray-700 mb-1">Category</label>
                <select
                  name="category"
                  value={itemFilters.category}
                  onChange={handleItemFilterChange}
                  className="w-full p-2 border rounded"
                >
                  <option value="">All Categories</option>
                  {categories.map((category) => (
                    <option key={category._id} value={category._id}>
                      {category.name}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-gray-700 mb-1">Search</label>
                <input
                  type="text"
                  name="search"
                  value={itemFilters.search}
                  onChange={handleItemFilterChange}
                  placeholder="Search items..."
                  className="w-full p-2 border rounded"
                />
              </div>
            </div>

            <div className="max-h-64 overflow-y-auto ">
              <table className="w-full">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="p-2 text-left">Category</th>
                    <th className="p-2 text-left">Brand</th>
                    <th className="p-2 text-left">Size </th>
                    <th className="p-2 text-left">Postion / Origin</th>
                    <th className="p-2 text-left">Unique Size / Amp</th>
                    <th className="p-2 text-left">Quantity</th>
                    <th className="p-2 text-left">Reserve for Branch</th>
                    <th className="p-2 text-left">Branch</th>
                    <th className="p-2 text-left">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((item) => (
                    <tr key={item._id} className="border-b hover:bg-gray-50">
                      <td className="p-2">{item.category.name}</td>
                      <td className="p-2">{item.brand}</td>
                      <td className="p-2">{item.size}</td>
                      <td className="p-2">{item.position || item.origin}</td>
                      <td className="p-2">{item.uniquesize || item.ampere}</td>
                      <td className="p-2">{item.quantity}</td>
                      <td className="p-2">{item.reserve_for_branch}</td>
                      <td className="p-2">{item.branch}</td>
                      <td className="p-2 flex gap-2">
                        <button
                          onClick={() => selectItem(item)}
                          disabled={isLoading.selectItem}
                          className="bg-green-500 text-white px-2 py-1 rounded hover:bg-green-600 disabled:opacity-50"
                        >
                          {isLoading.selectItem ? "Loading..." : "Select"}
                        </button>
                        <button
                          onClick={() => openViewModal(item)}
                          className="bg-teal-500 text-white px-2 py-1 rounded hover:bg-teal-600"
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <button
              onClick={closeModal}
              disabled={isLoading.closeModal}
              className="mt-4 bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 disabled:opacity-50"
            >
              {isLoading.closeModal ? "Loading..." : "Close"}
            </button>
          </div>
        </div>
      )}

      {isEditModalOpen && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center">
          <div className="bg-white p-6 rounded-lg w-full max-w-2xl">
            <h2 className="text-xl font-bold mb-4">Edit Stock-In</h2>
            <form onSubmit={handleEditSubmit}>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                  <label className="block text-gray-700 mb-1">Item</label>
                  <input
                    type="text"
                    value={
                      editFormData.item
                        ? `${editFormData.item.name} - ${editFormData.item.brand}`
                        : "N/A"
                    }
                    className="w-full p-2 border rounded bg-gray-100"
                    readOnly
                  />
                </div>
                <div>
                  <label className="block text-gray-700 mb-1">Quantity</label>
                  <input
                    type="number"
                    name="quantity"
                    value={editFormData.quantity}
                    onChange={handleEditInputChange}
                    placeholder="Quantity"
                    className="w-full p-2 border rounded"
                    required
                    min="1"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 mb-1">Unit Price</label>
                  <input
                    type="number"
                    name="unitprice"
                    value={editFormData.unitprice}
                    onChange={handleEditInputChange}
                    placeholder="Unit Price"
                    className="w-full p-2 border rounded"
                    required
                    min="0"
                    step="0.01"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 mb-1">Sale Price</label>
                  <input
                    type="number"
                    name="saleprice"
                    value={editFormData.saleprice}
                    onChange={handleEditInputChange}
                    placeholder="Sale Price"
                    className="w-full p-2 border rounded"
                    required
                    min="0"
                    step="0.01"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 mb-1">Total</label>
                  <input
                    type="number"
                    value={editFormData.quantity * editFormData.unitprice || 0}
                    placeholder="Total"
                    className="w-full p-2 border rounded bg-gray-100"
                    readOnly
                  />
                </div>
                <div>
                  <label className="block text-gray-700 mb-1">Note</label>
                  <input
                    type="text"
                    name="note"
                    value={editFormData.note}
                    onChange={handleEditInputChange}
                    placeholder="Note (optional)"
                    className="w-full p-2 border rounded"
                  />
                </div>
              </div>
              <div className="mt-4 flex gap-2 justify-end">
                <button
                  type="button"
                  onClick={closeEditModal}
                  className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={isLoading.submit}
                  className="bg-teal-500 text-white px-4 py-2 rounded hover:bg-teal-600 disabled:opacity-50"
                >
                  {isLoading.submit ? "Loading..." : "Update"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {isViewModalOpen && viewingItem && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center">
          <div className="bg-white p-6 rounded-lg w-full max-w-3xl">
            <h2 className="text-xl font-bold mb-4">
              {viewingItem.quantity && viewingItem.unitprice
                ? "Stock-In Details"
                : "Item Details"}
            </h2>
            {viewingItem.quantity && viewingItem.unitprice ? (
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div>
                  <h3 className="font-semibold text-lg mb-2">Stock-In Info</h3>
                  <div className="space-y-2">
                    {viewingItem.quantity && (
                      <p>
                        <span className="font-medium">Quantity:</span>{" "}
                        {viewingItem.quantity}
                      </p>
                    )}
                    {viewingItem.unitprice && (
                      <p>
                        <span className="font-medium">Unit Price:</span> $
                        {viewingItem.unitprice}
                      </p>
                    )}
                    {viewingItem.quantity && viewingItem.unitprice && (
                      <p>
                        <span className="font-medium">Total:</span> $
                        {(viewingItem.quantity * viewingItem.unitprice).toFixed(
                          2
                        )}
                      </p>
                    )}
                    {viewingItem.note && (
                      <p>
                        <span className="font-medium">Note:</span>{" "}
                        {viewingItem.note}
                      </p>
                    )}
                    {viewingItem.created_at && (
                      <p>
                        <span className="font-medium">Date:</span>{" "}
                        {new Date(viewingItem.created_at).toLocaleString()}
                      </p>
                    )}
                  </div>
                </div>

                <div>
                  <h3 className="font-semibold text-lg mb-2">Item Info</h3>
                  <div className="space-y-2">
                    {viewingItem.item?.name && (
                      <p>
                        <span className="font-medium">Name:</span>{" "}
                        {viewingItem.item.name}
                      </p>
                    )}
                    {viewingItem.item?.brand && (
                      <p>
                        <span className="font-medium">Brand:</span>{" "}
                        {viewingItem.item.brand}
                      </p>
                    )}
                    {viewingItem.item?.branch && (
                      <p>
                        <span className="font-medium">Branch:</span>{" "}
                        {viewingItem.item.branch}
                      </p>
                    )}
                    {viewingItem.item?.size && (
                      <p>
                        <span className="font-medium">Size:</span>{" "}
                        {viewingItem.item.size}
                      </p>
                    )}
                    {viewingItem.item?.uniquesize && (
                      <p>
                        <span className="font-medium">Unique Size:</span>{" "}
                        {viewingItem.item.uniquesize}
                      </p>
                    )}
                    {viewingItem.item?.ampere && (
                      <p>
                        <span className="font-medium">Ampere:</span>{" "}
                        {viewingItem.item.ampere}
                      </p>
                    )}
                    {viewingItem.item?.position && (
                      <p>
                        <span className="font-medium">Position:</span>{" "}
                        {viewingItem.item.position}
                      </p>
                    )}
                    {viewingItem.item?.origin && (
                      <p>
                        <span className="font-medium">Origin:</span>{" "}
                        {viewingItem.item.origin}
                      </p>
                    )}
                    {viewingItem.item?.category?.name && (
                      <p>
                        <span className="font-medium">Category:</span>{" "}
                        {viewingItem.item.category.name}
                      </p>
                    )}
                    {viewingItem.item?.reserve_for_branch && (
                      <p>
                        <span className="font-medium">Reserve for Branch:</span>{" "}
                        {viewingItem.item.reserve_for_branch}
                      </p>
                    )}
                  </div>
                </div>

                <div>
                  <h3 className="font-semibold text-lg mb-2">User Info</h3>
                  <div className="space-y-2">
                    {viewingItem.user?.name && (
                      <p>
                        <span className="font-medium">name:</span>{" "}
                        {viewingItem.user.username}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <h3 className="font-semibold">Basic Information</h3>
                  <div className="mt-2 space-y-2">
                    {viewingItem.name && (
                      <p>
                        <span className="font-medium">Name:</span>{" "}
                        {viewingItem.name}
                      </p>
                    )}
                    {viewingItem.brand && (
                      <p>
                        <span className="font-medium">Brand:</span>{" "}
                        {viewingItem.brand}
                      </p>
                    )}
                    {viewingItem.branch && (
                      <p>
                        <span className="font-medium">Branch:</span>{" "}
                        {viewingItem.branch}
                      </p>
                    )}
                    {viewingItem.quantity && (
                      <p>
                        <span className="font-medium">Quantity:</span>{" "}
                        {viewingItem.quantity}
                      </p>
                    )}
                  </div>
                </div>
                <div>
                  <h3 className="font-semibold">Additional Details</h3>
                  <div className="mt-2 space-y-2">
                    {viewingItem.size && (
                      <p>
                        <span className="font-medium">Size:</span>{" "}
                        {viewingItem.size}
                      </p>
                    )}
                    {viewingItem.uniquesize && (
                      <p>
                        <span className="font-medium">Unique Size:</span>{" "}
                        {viewingItem.uniquesize}
                      </p>
                    )}
                    {viewingItem.ampere && (
                      <p>
                        <span className="font-medium">Ampere:</span>{" "}
                        {viewingItem.ampere}
                      </p>
                    )}
                    {viewingItem.position && (
                      <p>
                        <span className="font-medium">Position:</span>{" "}
                        {viewingItem.position}
                      </p>
                    )}
                    {viewingItem.origin && (
                      <p>
                        <span className="font-medium">Origin:</span>{" "}
                        {viewingItem.origin}
                      </p>
                    )}
                    {viewingItem.category?.name && (
                      <p>
                        <span className="font-medium">Category:</span>{" "}
                        {viewingItem.category.name}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            )}
            <button
              onClick={closeViewModal}
              className="mt-6 bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
            >
              Close
            </button>
          </div>
        </div>
      )}

      <div className="overflow-x-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr className="bg-gray-200">
              <th className="p-2 text-left">Date</th>
              <th className="p-2 text-left">Category</th>
              <th className="p-2 text-left">Brand</th>
              <th className="p-2 text-left">Size </th>
              <th className="p-2 text-left">Unique Size / Amp</th>
              <th className="p-2 text-left">Postion / Origin</th>
              <th className="p-2 text-left">Branch</th>
              <th className="p-2 text-left">Quantity</th>
              <th className="p-2 text-left">Unit Price</th>
              <th className="p-2 text-left">Total</th>
              <th className="p-2 text-left">Note</th>
              <th className="p-2 text-left">Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredStockIns.map((stockIn) => (
              <tr key={stockIn._id} className="border-b hover:bg-gray-50">
                <td className="p-2">
                  {new Date(stockIn.created_at).toLocaleDateString() || "N/A"}
                </td>
                <td className="p-2">{stockIn.item?.category.name || "N/A"}</td>
                <td className="p-2">{stockIn.item?.brand || "N/A"}</td>
                <td className="p-2">{stockIn.item?.size || "N/A"}</td>
                <td className="p-2">
                  {stockIn.item?.uniquesize || stockIn.item?.ampere || "N/A"}
                </td>
                <td className="p-2">
                  {stockIn.item?.origin || stockIn.item?.position || "N/A"}
                </td>
                <td className="p-2">{stockIn.item?.branch || "N/A"}</td>
                <td className="p-2">{stockIn.quantity || 0}</td>
                <td className="p-2">${stockIn.unitprice || 0}</td>
                <td className="p-2">
                  ${(stockIn.quantity * stockIn.unitprice || 0).toFixed(2)}
                </td>
                <td className="p-2">{stockIn.note || "----"}</td>
                <td className="p-2 flex gap-2">
                  <button
                    onClick={() => handleEdit(stockIn)}
                    disabled={isLoading.edit}
                    className="bg-yellow-500 text-white px-2 py-1 rounded hover:bg-yellow-600 disabled:opacity-50"
                  >
                    {isLoading.edit ? "Loading..." : "Edit"}
                  </button>
                  <button
                    onClick={() => handleDelete(stockIn._id)}
                    disabled={isLoading.delete}
                    className="bg-red-500 text-white px-2 py-1 rounded hover:bg-red-600 disabled:opacity-50"
                  >
                    {isLoading.delete ? "Loading..." : "Delete"}
                  </button>
                  <button
                    onClick={() => openViewModal(stockIn)}
                    className="bg-teal-500 text-white px-2 py-1 rounded hover:bg-teal-600"
                  >
                    View
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default StockInPage;
